//caroussel vantagens revendedor
import { pagination } from 'instantsearch.js/es/widgets';
import Swiper, { Navigation, Autoplay , Pagination, Lazy } from 'swiper';
Swiper.use([Navigation, Pagination, Lazy, Autoplay]);
var swiperVantagem = new Swiper(".swiperVantagens", {
  slidesPerView: 2,
  spaceBetween: 25,
  loop: true,
  autoplay: true,
  centeredSlides: true,
  breakpoints: {
    // when window width is >= 640px
    768: {
      slidesPerView: 4.2,
      spaceBetween: 25
    },
    // when window width is >= 640px
    992: {
      slidesPerView: 5,
      spaceBetween: 25,
      loop: false,
      centeredSlides: false,
      autoplay: false
    }
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  }
});

var swiperCategoria = new Swiper(".banner-categoria", {
  slidesPerView: 1.3,
  spaceBetween: 10,
  watchOverflow: true,
  preloadImages: true,
  loop: false,
  centeredSlides: false,
  navigation: true,
  pagination: true,
  lazy: {
    checkInView: true,
    loadPrevNext: false,
    loadOnTransitionStart: true,
  },
  breakpoints: {
    768: {
      slidesPerView: 3.3,
      spaceBetween: 10
    },
    992: {
      slidesPerView: 4,
      spaceBetween: 10,
      loop: false,
      centeredSlides: false,
      pagination: false,
    }
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  }
});

  var swiperDuvidas = new Swiper(".slide-duvidas", {
    slidesPerView: 2,
    spaceBetween: 25,
    centeredSlides: true,
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    }
  });

  var swiperRegua = new Swiper(".swiper.regua", {
    slidesPerView: 1.2,
    // spaceBetween: 'auto',
    autoplay: true,
    loop: true,
    breakpoints: {
      // when window width is >= 640px
      768: {
        slidesPerView: 2.2,
        // spaceBetween: 'auto',
      },
      // when window width is >= 640px
      992: {
        slidesPerView: 4,
        spaceBetween: 28,
        loop: false

      }
    }
  });

  var swiperMenu = new Swiper(".banner-menu-mobile", {
    slidesPerView: 3.2,
    spaceBetween: 10,
    autoplay: true,
    // breakpoints: {
    //   // when window width is >= 640px
    //   768: {
    //     slidesPerView: 3.3,
    //     spaceBetween: 10
    //   },
    //   // when window width is >= 640px
    //   992: {
    //     slidesPerView: 5,
    //     spaceBetween: 25,
    //     loop: false,
    //     centeredSlides: false
    //   }
    // },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    }
  });
